import isValidVRN from "@shared/utils/checks/isValidVRN"
import { BaseFleetEntry } from "../../api/fleet"
import { isNotCoverDateMovedForward } from "./checks"
import { GeneratorProps } from "./types"

const validateVRN = (entry: Partial<BaseFleetEntry>, props: GeneratorProps) => {
  const { curentEntries, policyDuration, hasAdminAccess } = props
  if (!entry.registrationNumber) return `Registration number must be supplied`
  if (!isValidVRN(entry.registrationNumber))
    return `The supplied registration number ${entry.registrationNumber} is not a valid licence plate`
  // Although not strictly a vrn validation - to the user it makes most
  // sense to report the error against the vrn field
  if (!isNotCoverDateMovedForward(entry, curentEntries, policyDuration, hasAdminAccess))
    return `It looks like this vehicle is already on your policy. Please recheck and try again. If you need edit your cover dates, please use the edit cover date feature.`
  return undefined
}

export const generateValidateVRN = (props: GeneratorProps) => (entry: Partial<BaseFleetEntry>) =>
  validateVRN(entry, props)
